import hrOnboardingStatusGet from './hr-onboarding-status-get';
import hrOnboardingCreate from './hr-onboarding-create';
import hrOnboardingGet from './hr-onboarding-get';
import hrOnboardingLink from './hr-onboarding-link';
import hrOnboardingStatusSet from './hr-onboarding-status-set';
import hrOnboardingSuperfund from './hr-onboarding-superfund';
import hrOnboardingUpdateTenantSettings from '@/lib/request/svc/hr/hr-tenant-settings-put';
import { createTenantSettings } from '@/lib/request/svc/hr/hr-tenant-settings-post';
import getTenantSettings from '@/lib/request/svc/hr/hr-tenant-settings-get';
import listSuperFunds from '@/lib/request/svc/hr/get-super-funds';

const onboarding = {
  create: hrOnboardingCreate,
  link: hrOnboardingLink,
  get: hrOnboardingGet,
  status: hrOnboardingStatusGet,
  statusUpdate: hrOnboardingStatusSet,
  superFund: hrOnboardingSuperfund,
  upsertTenantSetting: hrOnboardingUpdateTenantSettings,
  createTenantSetting: createTenantSettings,
  getTenantSetting: getTenantSettings,
  listSuperFunds: listSuperFunds,
};

export const HR_ONBOARDING_STATES = {
  TODO: 'TODO',
  STARTED: 'STARTED',
  RESET: 'RESET',
  REVIEW: 'REVIEW',
  SUBMITTED: 'SUBMITTED',
  APPROVED: 'APPROVED',
};

export const HR_ONBOARDING_STATES_TO_STRING = {
  0: 'TODO',
  1: 'STARTED',
  2: 'REVIEW',
  4: 'SUBMITTED',
  5: 'APPROVED',
};

export const HR_ONBOARDING_STATES_TO_ID = {
  TODO: 0,
  STARTED: 1,
  REVIEW: 2,
  SUBMITTED: 4,
  APPROVED: 5,
};

export { onboarding };
export default { onboarding };
